import * as React from 'react';

import {DynamicStatusButton} from 'shells/button/dynamic-status-button/dynamic-status-button';

import {RouteContext} from '../../../route-context';
import {useGetInboxStatus} from '../../../setup/text-messaging/graphql/hooks';
import {
    getIsEnrolled,
    getIsUnderReview,
    getPhoneNumber,
    getRemainingCredits,
} from '../../../setup/text-messaging/helpers';

import {getPopoverContent, getStatusDescription, getStatusText} from './helpers';

type Props = {
    userCanAccessSetup: boolean;
};

export function PhoneStatusButton(props: Props) {
    const {userCanAccessSetup} = props;
    const [isDialogOpen, setIsDialogOpen] = React.useState<boolean>(false);
    const {inboxStatus, isLoading} = useGetInboxStatus();
    const {isEmbedded} = React.useContext(RouteContext);

    const isEnrolled = getIsEnrolled(inboxStatus);
    const phoneNumber = getPhoneNumber(inboxStatus);
    const remainingCredits = getRemainingCredits(inboxStatus);
    const isUnderReview = getIsUnderReview(inboxStatus);
    const isBeta = NutClientConfig.hasNutshellInboxBeta;

    if (isLoading) {
        return null;
    }

    return (
        <DynamicStatusButton
            key='phone'
            text={getStatusText(isEnrolled, phoneNumber, isUnderReview)}
            headerContent={getStatusDescription(isEnrolled, phoneNumber, isUnderReview)}
            headerType={isEnrolled ? 'success' : 'warning'}
            isDialogOpen={isDialogOpen}
            setIsDialogOpen={setIsDialogOpen}
            popoverContent={getPopoverContent({
                isEnrolled,
                phoneNumber,
                remainingCredits,
                userCanAccessSetup,
                isBeta,
                isUnderReview,
                isEmbedded,
            })}
        />
    );
}
